/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const currentUser = useAuth()

  return (
    <>
      {currentUser?.currentUser?.user?.user_type === 'ADMIN' && (
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/general/gen008.svg'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />
      )}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Customer</span>
        </div>
      </div> */}

      {currentUser?.currentUser?.user?.user_type === 'CUS' && (
        <SidebarMenuItem
          to='/customer-dashboard'
          icon='/media/icons/duotune/graphs/gra011.svg'
          title='Customer Dashboard'
          fontIcon='bi-layers'
        />
      )}

      {/* <SidebarMenuItem
        to='/financial-dashboard'
        icon='/media/icons/duotune/graphs/gra003.svg'
        title='Financial Dashboard'
        fontIcon='bi-layers'
      /> */}
    </>
  )
}

export {SidebarMenuMain}
